import React, { useState, forwardRef, useCallback } from 'react';

type Props = {
  className: string,
  children: React.Node,
};

export const ScrollDrag = forwardRef(({ className, children }: Props, ref) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const [clientX, setClientX] = useState(0);

  const onMouseDown = useCallback(
    e => {
      setIsScrolling(true);
      setClientX(e.clientX);
    },
    [setIsScrolling, setClientX]
  );

  const onMouseUp = useCallback(() => {
    setIsScrolling(false);
  }, [setIsScrolling]);

  const onMouseMove = useCallback(
    e => {
      if (isScrolling) {
        ref.current.scrollLeft = ref.current.scrollLeft - e.clientX + clientX;
        setClientX(e.clientX);
      }
    },
    [isScrolling, setClientX, ref, clientX]
  );

  return (
    <div
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseMove={onMouseMove}
      className={className}
      role="presentation"
    >
      {children}
    </div>
  );
});

ScrollDrag.defaultProps = {
  className: '',
};
